/**
 * @generated SignedSource<<fa5565faf251bfeff77456576150f26b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CompetitionCardFooterFragment$data = {
  readonly rewards: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"RewardFragment">;
      };
    }>;
    readonly totalCount: number;
  };
  readonly " $fragmentType": "CompetitionCardFooterFragment";
};
export type CompetitionCardFooterFragment$key = {
  readonly " $data"?: CompetitionCardFooterFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CompetitionCardFooterFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CompetitionCardFooterFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        }
      ],
      "concreteType": "RewardConnection",
      "kind": "LinkedField",
      "name": "rewards",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RewardEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Reward",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "RewardFragment"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "rewards(first:1)"
    }
  ],
  "type": "Competition",
  "abstractKey": null
};

(node as any).hash = "0c4c7c1a001a84b118c3fc08ee1ec951";

export default node;
